import { useEffect, useState } from "react";
import Swal from 'sweetalert2';
import swal from 'sweetalert2';
import moment from "moment";
import Select from 'react-select';
import defaultUserImg from '../../assets/images/user.jpg'
import AddUsersSubscriptionFile from "./addUsersSubscriptionFile";
import EditUserSubscription from "./editUserSubscription";
import { getPrimaryMembersForSubscriptionReport } from "../api/usersAPI";

const UsersSubscriptionReport = (props) => {
    
    const [addFile,                   setAddFile]                  = useState(false);
    const [usersSubscriptionReport,   setUsersSubscriptionReport]  = useState([]);
    const [isInit,                    setIsInit]                   = useState(true);
    const [usersSubscriptionTable,    setUsersSubscriptionTable]   = useState(null);
    const [refresh,                   setRefresh]                  = useState(false);
    const [memberDetails,             setMemberDetails]            = useState({});
    const [type,                      setType]                     = useState([{ value:  'All', label: 'All'},{ value:  'Active', label: 'Active'},{ value:  'Expired', label: 'Expired'}]);
    const [statusType,                setStatusType]               = useState(type[0].value);
 
    useEffect(() => {
        props.title('Subscription Report','user-subscription')
        fetchUsersSubscription();

    },[]);

    useEffect(() => {
        fetchUsersSubscription();
     },[ refresh]);

    useEffect(() => {       
        if (!isInit) {
            fillDataTable();
        };
    }, [usersSubscriptionReport]);

    useEffect(() => {
        if( !isInit && statusType ){
            $('#tblUsersSubscriptionReport').KTDatatable().destroy(); 
            fillDataTable();
        };
    },[statusType])

    const refetchReport = () => setRefresh((r) => !r);

    function exportSheet(type) {
        usersSubscriptionTable.update({
            headers: true,
            formats: ["xlsx", "csv"],
            filename: `${moment().format("DD-MM-YYYY")} - Subscription Sheet`, // pass in a new set of properties
            columns: "Email"
 
        });

        if (type == 'xlsx') {
            $('.button-default.xlsx').click();
        } else {
            $('.button-default.csv').click();
        }
        $('.tableexport-caption').addClass('hidden');
    };

    const fetchUsersSubscription = async() => {
        try {
            swal.fire({
                titleText: 'Loading',
                text: 'Please Wait...',
                showConfirmButton: false,
                onOpen: () => {
                    swal.showLoading();
                }
            });
            const response = await getPrimaryMembersForSubscriptionReport();
            isInit ? setIsInit(false) : $('#tblUsersSubscriptionReport').KTDatatable().destroy(); 
            setUsersSubscriptionReport(response)
            swal.close();
        } catch (err) {
            Swal.fire({
                icon      : 'error',
                titleText : err.message
            })  
        }
    }

    function fillDataTable() {
        var ReportList = []; 

        if (statusType == 'All') {
            ReportList = usersSubscriptionReport;
        }else{
            ReportList = usersSubscriptionReport.filter(i => i.IsSubscriptionExpires == (statusType == "Active" ? "Y" : "N"));

        }
        const dataTable = $('#tblUsersSubscriptionReport').KTDatatable({
            data: {
                saveState: false,
                source: ReportList,
            },
            layout: {
                scroll: false,
                footer: false,
            },
            sortable: true,
            pagination: true,
            search: {
                input: $('#generalSearch'),
            },
            columns: [
                {
                    field: 'Name',
                    title: 'Member',
                    template: function (row) {
                        return `<div class="kt-user-card-v2">
                                    <div class="kt-user-card-v2__pic">
                                    ${(row.Photo && row.Photo != '') ? `<img src="${row.Photo}" alt="user-profile" height="50" width="50">` : `<img src="${defaultUserImg}" alt="user-profile" height="50" width="50">`}
                                    </div>
                                    <div class="kt-user-card-v2__details text-clip">
                                        <span class="kt-user-card-v2__name text-clip"> ${row.Name} </span> <span class="kt-user-card-v2__desc text-clip"> ${row['Membership Number']} </span>
                                    </div>
                                </div>`
                    },
                    width: 180,

                },
                {
                    field: ' ',
                    title: 'Contact',
                    template: function (row) {
                        return `<div class="kt-user-card-v2">
                                    <div class="kt-user-card-v2__details text-clip">
                                        <span class="kt-user-card-v2__name text-clip"> ${row.Mobile} </span> 
                                        <span class="kt-user-card-v2__desc text-clip"> ${row.Email} </span>
                                    </div>
                                </div>`
                    },
                    width: 180,

                },
                {
                    field: 'Plan',
                    title: 'Plan',
                    width: 130,
                },
                {
                    field: 'Membership Type',
                    title: 'Membership Type',
                    width: 130,
                },
                {
                    field: 'SubscriptionStartsFrom',
                    title: 'Subscription',
                    width: 180,
                    template: function (row) {
                        return row.IsSubscriptionExpires == 'Y' ? `<strong style="font-weight: 600"> <span class="kt-user-card-v2__desc text-clip"> ${moment(moment(row?.SubscriptionStartsFrom).format('YYYY-MM-DD')).isSame(moment(row?.SubscriptionExpiresOn).format('YYYY-MM-DD')) ? moment(row.SubscriptionStartsFrom).format('DD MMM YYYY') : moment(row.SubscriptionStartsFrom).format('DD MMM YYYY') + ' - ' + moment(row.SubscriptionExpiresOn).format('DD MMM YYYY') } </span></strong>` : '<div><span class="">' + 'Expired' + '</span></div>'
                    }
                    
                },
                {
                    field: 'IsSubscriptionExpires',
                    title: 'Status',
                    width: 80,
                    template: function (row) {
                        if (row.IsSubscriptionExpires == 'N') {
                            return '<div><span class="btn btn-bold btn-font-sm  btn-label-warning">' + 'Expired' + '</span></div>';
                        } else {
                            return '<div><span class="btn btn-bold btn-font-sm  btn-label-success" style="padding-left: 9px">' + 'Active' + '</span></div>';
                        }
                    }
                },
                {
                    field: '',
                    title: '',
                    width: 60,
                    template: function (row) {
                        return showEditButton(row)
                    }
                },
                
            ]
            ,
            rows: {
                autoHide: false,
            }
        });
        Config.Core.InitPopover();

        function showEditButton(row) {
            var optString = '';

            optString += '<center>'

            optString += `<button type="button"  class="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs btn-edit"><i class="flaticon2-edit"></i></button>`

            optString += '</center>'

            return optString;
        }

        dataTable.on('click', '.btn-edit', function (ss) {///edit
            const index = $(ss.currentTarget).parents('tr').index();
               
            if (dataTable.dataSet && dataTable.dataSet.length > 0 && dataTable.dataSet[index]) {
                editHandler(dataTable.dataSet[index])
            } 
        });  
        // export to excel
        const usersSubscriptionTable = $('.kt-datatable__table').tableExport({
            formats: ["xlsx", "csv"],
            headers: true,
            filename: `${moment().format("DD-MM-YYYY")} - Subscription Report`,
        });
        setUsersSubscriptionTable(usersSubscriptionTable);
        $('.tableexport-caption').addClass('hidden');
        
    };
    
    const editHandler = (obj) => {
        setMemberDetails(obj)
    }; 
    
    return(
        <>  
            <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-tb0" id="kt_content">
                <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid margin-t20">
                    <div className="kt-portlet">
                        <div className="kt-portlet__body padding-t20 padding-b0">
                            <div id="ControlHolder" className="kt-form kt-form--label-right padding-10" role="form">
                                <div className="row"> 
                                    <label className="col-form-label col-sm-1 text-right">Type</label>
                                    <div className="form-group col-sm-2 pnlType">
                                        <div >
                                            <Select 
                                                id="ddlType" 
                                                name="ddlType"
                                                className="multi-custom "
                                                defaultValue={type.find((m) => m.value[0] )  || ''}
                                                onChange={(event) => setStatusType(event.value)}
                                                options={type}
                                            />
                                        </div>
                                    </div> 
                                    <div className="form-group col-sm-3">
                                        <div className="input-group">
                                            <div className="kt-input-icon kt-input-icon--left">
                                                <input 
                                                    type="text" 
                                                    className="form-control clientSearch" 
                                                    placeholder="Search Member..." 
                                                    id="generalSearch" 
                                                />
                                                <span className="kt-input-icon__icon kt-input-icon__icon--left"><span><i className="la la-search"></i></span></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3"></div>
                                    <div className="col-md-1">
                                        <div className="dropdown">
                                            <button className="btn btn-label-brand dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                Export
                                            </button>
                                            <div className="dropdown-menu " aria-labelledby="dropdownMenuButton" x-placement="bottom-start" style={{position: 'absolute', willChange: 'transform', top: '0px', left: '0px', transform: 'translate3d(0px, 38px, 0px)'}}>
                                                <button 
                                                    id="btn-export-excel" 
                                                    type="button" 
                                                    className="dropdown-item"
                                                    onClick={() => exportSheet('xlsx')}

                                                > Excel 
                                                </button>
                                                <button 
                                                    id="btn-export-csv" 
                                                    type="button" 
                                                    className="dropdown-item"
                                                    onClick={() => exportSheet('csv')}
                                                >  Csv </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div  className="form-group col-sm-2 pnlStatus ">
                                        <button className="btn btn-label-brand btn-block margin-0"
                                            onClick={(e) => {e.preventDefault(), setAddFile(true)}}
                                        >
                                            <i className="la la-upload"></i>
                                            Upload File
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div id="tblUsersSubscriptionReport" className="table table-bordered table-hover custom-datatable"></div>
                        </div>
                    </div>
                </div>
            </div>
            {addFile && (
                <AddUsersSubscriptionFile
                    show={addFile}
                    onDismissModal={setAddFile}
                    refetchReport={() => refetchReport()}
                />
            )}  
            {Object.keys(memberDetails).length > 0 && (
                <EditUserSubscription
                    show={memberDetails}
                    onDismissModal={setMemberDetails}
                    memberDetails={memberDetails}
                    setMemberDetails={setMemberDetails}
                    refetchReport={() => refetchReport()}
                />
            )}
        </>
    )
}

export default UsersSubscriptionReport;